import { useNavigate } from 'react-router';
import { Box, List, ListItem, ListItemIcon, ListItemText, ListItemButton } from '@mui/material';

interface PageMenuProps {
    menu: any[];
    activeMenu: [string, React.Dispatch<React.SetStateAction<string>>];
    privateChargingNetworkSubscription?: boolean;
    onMenuItemClick?: () => void;
}

const PageMenu: React.FC<PageMenuProps> = ({ menu, activeMenu, privateChargingNetworkSubscription, onMenuItemClick }) => {
    const navigate = useNavigate();
    const [active, setActive] = activeMenu;

    const handleMenuClick = (item: any) => {
        setActive(item.title);
        navigate(item.url);
        onMenuItemClick?.();  // Call onMenuItemClick if provided
    };

    return (
        <Box sx={{ 
            width: '100%',
            height: '100%',
            bgcolor: 'background.paper',
            overflow: 'hidden'
        }}>
            <List sx={{ 
                height: '100%',
                overflow: 'auto',
                py: 1
            }}>
                {menu.map((item: any, index: number) => {
                    if ((privateChargingNetworkSubscription && item.pcn) || !item.pcn) {
                        return (
                            <ListItem
                                key={index}
                                disablePadding
                                onClick={() => handleMenuClick(item)}
                                sx={{
                                    bgcolor: active === item.title ? 'action.selected' : 'transparent'
                                }}
                            >
                                <ListItemButton>
                                    <ListItemIcon>
                                        <span className="material-symbols-outlined" style={{ color: '#666' }}>
                                            {item.icon || "data_thresholding"}
                                        </span>
                                    </ListItemIcon>
                                    <ListItemText 
                                        id={`menuOption_${item.title.replace(/\s+/g, '')}`}
                                        primary={item.title}
                                    />
                                </ListItemButton>
                            </ListItem>
                        );
                    }
                    return null;
                })}
            </List>
        </Box>
    );
};

export default PageMenu;
